import { Box, CircularProgress, Icon, Skeleton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import UploadHistoryDrawer from './UploadHistoryDrawer'

const ResumeParsingStatus = ({ isParsing, redundantCount, isLoading, refreshQueries }) => {
  const navigate = useNavigate()

  const isRedundant = redundantCount !== 0
  const multipleStatus = isParsing && isRedundant
  const [selected, setSelected] = useState(null)
  const [drawerState, setDrawerState] = useState(false)

  const handleToggle = () => {
    setSelected((prev) => (prev === 'isParsing' ? 'isRedundant' : 'isParsing'))
  }

  const handleDrawer = (anchor, open) => () => {
    refreshQueries()
    setDrawerState({ ...drawerState, [anchor]: open })
  }

  useEffect(() => {
    if (multipleStatus) {
      setSelected('isParsing')
    } else if (!isParsing && isRedundant) {
      setSelected('isRedundant')
    } else {
      setSelected('isParsing')
    }
    refreshQueries()
  }, [isParsing, isRedundant])

  return (
    <>
      <Box sx={{ display: 'flex', gap: '16px' }}>
        {isParsing && (
          <Box
            onClick={multipleStatus && selected !== 'isParsing' ? handleToggle : () => {}}
            sx={{
              width: selected === 'isParsing' ? '100%' : '60px',
              transition: 'all 0.3s linear',
              overflow: 'clip',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              backgroundColor: 'primary.light',
              borderRadius: '2px',
              borderLeft: '3px solid',
              borderColor: 'primary.main',
              marginBottom: '16px',
              cursor: selected !== 'isParsing' && 'pointer',
              '&:hover': {
                backgroundColor: selected !== 'isParsing' && '#BCEDED',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <CircularProgress color="primary" size={20} />
              {selected === 'isParsing' && (
                <Typography noWrap>You've ongoing resume parsing in progress</Typography>
              )}
            </Box>

            {selected === 'isParsing' && (
              <Typography
                noWrap
                onClick={handleDrawer('right', true)}
                sx={{ color: 'alternate.main', textDecoration: 'underline', cursor: 'pointer' }}
              >
                View
              </Typography>
            )}
          </Box>
        )}
        {isRedundant && (
          <Box
            onClick={multipleStatus && selected !== 'isRedundant' ? handleToggle : () => {}}
            sx={{
              width: selected === 'isRedundant' ? '100%' : '110px',
              transition: 'all 0.3s linear',
              overflow: 'clip',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              backgroundColor: 'light-warning.main',
              borderRadius: '2px',
              borderLeft: '3px solid #F3BF3A',
              marginBottom: '16px',
              cursor: selected !== 'isRedundant' && 'pointer',
              '&:hover': {
                backgroundColor: selected !== 'isRedundant' && '#F8E5AB',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <Icon sx={{ color: 'warning.main' }}>error</Icon>
              {isLoading ? (
                <Skeleton variant="text" width="380px" />
              ) : (
                <Typography noWrap>
                  {selected === 'isRedundant'
                    ? `${redundantCount} talents excluded from the list due to redundancy`
                    : `(${redundantCount})`}
                </Typography>
              )}
            </Box>
            {selected === 'isRedundant' && (
              <Typography
                noWrap
                sx={{ color: 'yellow-02.main', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => navigate('/app/recruitment/external-talent/redundant')}
              >
                View talent
              </Typography>
            )}
          </Box>
        )}
      </Box>

      {/* Upload history drawer */}
      <UploadHistoryDrawer drawerState={drawerState} handleDrawer={handleDrawer} />
    </>
  )
}

export default ResumeParsingStatus
